import React, { useState, useEffect, useRef } from 'react';
import { TextField, Button, Grid, FormHelperText, Typography, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CustomerDropDownWithLock from './components/CustomerDropDownWithLock';
import { QuattrLogoSpinner } from './components/QuattrLogoSpinner';
import { fetchAIBasedContent } from '../../utility/cr-common';
import { AxiosError } from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { CONTINUE_USING_TEXT, calculateRows } from './components/ToolsStyleWrapper';
import LockOpenIcon from '@material-ui/icons/Lock';
import {
  COMPONENT_NAMES,
  SCREEN_NAMES,
  CONTENT_AI_TOOL_NAME,
  CONTENT_AI_TOOL_CATEGORY,
  trackAnalyticsEvent,
} from '../../../src/constants/analyticsMeta';
import {
  getToolsUsageCreditsNeeded,
  handleGenerateOutput,
  PAID_TOOLS_PROMPT_FOR,
  resetCaptcha,
} from '../../utility/common';
import Cookies from 'js-cookie';
import { SkipCaptcha } from './components/SkipCaptcha';
import { useSession } from '../../utility/services/customHooks';
import { SUBSCRIPTION_STATUS } from '../../constants/common';
import CreditsInfo from './components/CreditsInfo';
import { PremiumToolsIcon } from '../../utility/tools-config';
import { LANGUAGES } from '../../constants/CountryAndLanguages';
import { Lock } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({}));

const ParagraphGenerator = ({
  classes,
  setShowSignUpPage,
  user,
  handleResetUsage,
  hasValidSubscription,
  enableLockedOption,
  isQwaDashboard = false,
  isCreditsShown = false,
  creditsRemaining = 0,
  usagePerDay = 0,
  setShowBuyOnePass,
  setIsRedirectToWebflow,
  setShowMinimumCreditsNeededMsg = (a) => {},
  setShowVerifyEmailPopup,
  freeToolsUsage = 0,
  showFreeToolsUsage = false,
  isCorpEmail = false,
}) => {
  const ownClasses = useStyles();
  const qttr_tools_auth = Cookies.get('qttr_tools_auth');
  const qttr_tools_daypass_auth = Cookies.get('qttr_tools_daypass_auth');
  const [topic, setTopic] = useState('');
  const [keywords, setKeywords] = useState('');
  const [numSentences, setNumSentences] = useState('5');
  const [tone, setTone] = useState('Formal');
  const [outputLanguage, setOutputLanguage] = useState('English');
  const [instructions, setInstructions] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState('');
  const [copied, setCopied] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [captchaError, setCaptchaError] = useState('');
  const [creditsNeeded, setCreditsNeeded] = useState(1);
  const inputSelectionRef = useRef<HTMLInputElement>(null);
  const session = useSession();

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    setCaptchaError('');
  };

  const numbers = ['1', '3', '5', '10', '15', '20', '25'];
  const NumberOptions = numbers.map((number) => {
    // Keep the first item as a number
    if (['1', '3', '5'].includes(number)) {
      return number;
    }

    // Convert the rest to objects, include a React component for the icon
    return {
      name: number,
      requireLogin: !hasValidSubscription && !enableLockedOption,
      icon:
        !hasValidSubscription && !enableLockedOption ? (
          <LockOpenIcon className={classes.unlockIcon} />
        ) : (
          <PremiumToolsIcon />
        ), // This is a JSX element representing the icon
    };
  });

  const changeToneOptions = [
    'Formal',
    'Casual',
    'Neutral',
    'Factual',
    {
      name: 'Authoritative',
      requireLogin: !hasValidSubscription && !enableLockedOption,
      icon:
        !hasValidSubscription && !enableLockedOption ? (
          <LockOpenIcon className={classes.unlockIcon} />
        ) : (
          <PremiumToolsIcon />
        ),
    },
    {
      name: 'Conversational',
      requireLogin: !hasValidSubscription && !enableLockedOption,
      icon:
        !hasValidSubscription && !enableLockedOption ? (
          <LockOpenIcon className={classes.unlockIcon} />
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z"
              fill="#FFC72C"
            />
          </svg>
        ),
    },
    {
      name: 'Persuasive',
      requireLogin: !hasValidSubscription && !enableLockedOption,
      icon:
        !hasValidSubscription && !enableLockedOption ? (
          <LockOpenIcon className={classes.unlockIcon} />
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z"
              fill="#FFC72C"
            />
          </svg>
        ),
    },
    {
      name: 'Business Formal',
      requireLogin: !hasValidSubscription && !enableLockedOption,
      icon:
        !hasValidSubscription && !enableLockedOption ? (
          <LockOpenIcon className={classes.unlockIcon} />
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z"
              fill="#FFC72C"
            />
          </svg>
        ),
    },
    {
      name: 'Creative / Descriptive',
      requireLogin: !hasValidSubscription && !enableLockedOption,
      icon:
        !hasValidSubscription && !enableLockedOption ? (
          <LockOpenIcon className={classes.unlockIcon} />
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z"
              fill="#FFC72C"
            />
          </svg>
        ),
    },
  ];

  useEffect(() => {
    trackAnalyticsEvent({
      isAnonymousUser: !user,
      payload: {
        label: 'Visited Free Tool',
        component_name: COMPONENT_NAMES.contentai_ai_tools,
        screen_name: SCREEN_NAMES.contentai_ai_tools,
        tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
        tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
        isQwaDashboard: isQwaDashboard,
      },
    });
  }, []);

  const handleGenerateParagraph = async (isContinueWriting = false) => {
    try {
      setLoading(true);
      if (!topic) {
        setError('topic');
        return;
      }
      if (!(recaptchaValue || qttr_tools_auth || user)) {
        setCaptchaError('recaptchaValue');
        return;
      }
      setCaptchaError('');
      setError('');
      // You can adjust the promptConfig as per your requirements
      const res = await fetchAIBasedContent({
        promptFor: 'PUBLIC_UTILITY.WRITE_PARAGRAPH',
        promptConfig: {
          topic,
          noOf: numSentences,
          target_keywords_list: keywords,
          specialInstructions: instructions,
          tone: tone,
          language: outputLanguage,
          prevText: isContinueWriting ? result : '',
          isContinueWriting: isContinueWriting,
        },
        tokenLimit: 10000,
        isPublicApi: true,
        reCAPTCHAToken: recaptchaValue,
      });
      if (res) {
        trackAnalyticsEvent({
          eventFor: 'button',
          buttonText: '',
          counterName: `${CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools} Outputs`,
          isAddCount: true,
          isAnonymousUser: !user,
          user: user,
          payload: {
            label: 'Generate Output',
            component_name: COMPONENT_NAMES.contentai_ai_tools,
            screen_name: SCREEN_NAMES.contentai_ai_tools,
            tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
            tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
            special_instructions_yn: instructions ? 'Yes' : 'No',
            isQwaDashboard: isQwaDashboard,
            creditsConsumed: isContinueWriting ? 1 : creditsNeeded ? creditsNeeded : 1,
            isContinueWriting: isContinueWriting,
            language: outputLanguage || 'English',
            tone: tone,
            noOfSentences: numSentences,
          },
        });
        if (handleResetUsage) {
          handleResetUsage();
        }
      }
      setResult(isContinueWriting ? `${result} ${res}` : res);
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError?.response) {
        if (axiosError.response.status === 403) {
          setShowSignUpPage(CONTINUE_USING_TEXT, {
            tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
            tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
          });
          trackAnalyticsEvent({
            eventFor: 'button',
            isAnonymousUser: !user,
            payload: {
              label: 'Reached your maximum usage limit',
              component_name: COMPONENT_NAMES.contentai_ai_tools,
              screen_name: SCREEN_NAMES.contentai_ai_tools,
              tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
              tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
              isQwaDashboard: isQwaDashboard,
            },
          });
        }
      }
      console.error('handleGenerateSummary:: ', error);
    } finally {
      setRecaptchaValue(null);
      resetCaptcha();
      setLoading(false);
    }
  };

  const handleCopyText = () => {
    const inputElement = inputSelectionRef?.current as any;
    if (inputElement) {
      const copiedText = inputElement?.value?.substring(
        inputElement?.selectionStart || 0,
        inputElement?.selectionEnd || 0
      );
      if (copiedText) {
        navigator.clipboard.writeText(copiedText);
        setCopied(true);
        trackAnalyticsEvent({
          eventFor: 'button',
          buttonText: '',
          counterName: 'Outputs Accepted',
          isAddCount: true,
          user,
          isAnonymousUser: !user,
          payload: {
            label: 'Copy Generated Output',
            component_name: COMPONENT_NAMES.contentai_ai_tools,
            screen_name: SCREEN_NAMES.contentai_ai_tools,
            tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
            tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
            special_instructions_yn: instructions ? 'Yes' : 'No',
            isQwaDashboard: isQwaDashboard,
            isManualCopy: true,
          },
        });
      } else {
        navigator.clipboard.writeText(result);
        setCopied(true);
        trackAnalyticsEvent({
          eventFor: 'button',
          buttonText: '',
          counterName: 'Outputs Accepted',
          isAddCount: true,
          user,
          isAnonymousUser: !user,
          payload: {
            label: 'Copy Generated Output',
            component_name: COMPONENT_NAMES.contentai_ai_tools,
            screen_name: SCREEN_NAMES.contentai_ai_tools,
            tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
            tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
            special_instructions_yn: instructions ? 'Yes' : 'No',
            isQwaDashboard: isQwaDashboard,
          },
        });
      }
    }

    setTimeout(() => {
      setCopied(false);
    }, 2000); // Change the text back to 'Copy Text' after 2 seconds
  };

  useEffect(() => {
    const promptFor = PAID_TOOLS_PROMPT_FOR.PARAGRAPH_GENERATOR;
    const promptConfig = {
      topic,
      noOf: numSentences,
      target_keywords_list: keywords,
      specialInstructions: instructions,
      tone: tone,
      language: outputLanguage,
    };
    setCreditsNeeded(getToolsUsageCreditsNeeded(promptFor, promptConfig));
  }, [user, topic, numSentences, keywords, instructions, tone, outputLanguage]);

  return (
    <div className={classes.container}>
      {loading && <QuattrLogoSpinner classes={classes} />}
      {result ? (
        <>
          <TextField
            inputRef={inputSelectionRef}
            fullWidth
            multiline
            rows={calculateRows(result)}
            margin="normal"
            placeholder="Generated Text"
            value={result}
            className={`${classes.textAreaInput} no-border background-gray`}
            maxRows={200}
            InputProps={{
              style: { borderRadius: '4px !important', padding: '16px' },
            }}
            minRows={20}
            variant="outlined"
            onCopy={handleCopyText}
          />
          <div className={`dflex j-flex-end ${classes.outputActionBtnWrapper}`} style={{ marginTop: '16px' }}>
            <Button
              className={`${classes.toolsYellowCTA} ${classes.toolsOutlinedCTA}`}
              disabled={loading}
              style={{ float: 'right', marginRight: '16px' }}
              onClick={() => {
                setResult('');
                trackAnalyticsEvent({
                  eventName: 'Clicked on Go back',
                  payload: {
                    label: 'Clicked on Go back',
                  },
                });
              }}
            >
              Go back
            </Button>
            <Button
              className={classes.toolsYellowCTA}
              disabled={loading}
              style={{ float: 'right', marginRight: '16px' }}
              onClick={handleCopyText}
            >
              {copied ? 'Copied!' : 'Copy Text'}
            </Button>
            <Button
              className={classes.toolsYellowCTA}
              disabled={loading}
              style={{
                float: 'right',
                background: !hasValidSubscription && !enableLockedOption ? 'lightgray' : '#FFC72C',
              }}
              onClick={() => {
                if (setShowSignUpPage && !hasValidSubscription && !enableLockedOption) {
                  setShowSignUpPage("'Continue Writing'", {
                    tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                    tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                  });
                  trackAnalyticsEvent({
                    eventFor: 'button',
                    isAnonymousUser: !user,
                    payload: {
                      label: 'Clicked Locked Option',
                      component_name: COMPONENT_NAMES.contentai_ai_tools,
                      screen_name: SCREEN_NAMES.contentai_ai_tools,
                      tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                      tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                      option_name: 'Continue Writing',
                      isQwaDashboard: isQwaDashboard,
                    },
                  });
                } else {
                  handleGenerateOutput(
                    creditsRemaining,
                    creditsNeeded,
                    isQwaDashboard,
                    session,
                    qttr_tools_daypass_auth,
                    setShowMinimumCreditsNeededMsg,
                    setShowBuyOnePass,
                    handleGenerateParagraph,
                    trackAnalyticsEvent,
                    freeToolsUsage,
                    showFreeToolsUsage,
                    true
                  );
                }
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                Continue Writing
                {isCreditsShown || !isQwaDashboard || showFreeToolsUsage ? (
                  <span style={{ fontSize: '12px' }}>(Uses 1 Credit)</span>
                ) : (
                  ''
                )}
              </div>
              {!hasValidSubscription && !enableLockedOption ? (
                <>
                  &nbsp; <Lock className={classes.lockIcon} />
                </>
              ) : null}
            </Button>
          </div>
        </>
      ) : (
        <>
          <TextField
            fullWidth
            label="Enter Topic"
            value={topic}
            variant="outlined"
            InputProps={{
              style: { backgroundColor: '#fff', borderRadius: '4px !important' },
            }}
            onChange={(e) => setTopic(e.target.value)}
            className={`${classes.textAreaInput} no-border mb-0`}
            error={!!error}
            helperText={error.includes('topic') ? '* Required' : error.includes('Please sign up') ? error : ''}
          />
          <TextField
            fullWidth
            label="Keywords (Optional)"
            value={keywords}
            variant="outlined"
            placeholder="Enter target keywords separated by ,"
            InputProps={{
              style: { backgroundColor: '#fff', borderRadius: '4px !important' },
            }}
            onChange={(e) => setKeywords(e.target.value)}
            className={`${classes.textAreaInput} no-border`}
          />
          <div className="mb-15">
            <CustomerDropDownWithLock
              label="Number of Sentences"
              value={numSentences}
              options={NumberOptions}
              onChange={(e) => {
                const value = e.target.value as string;
                const option = NumberOptions.find((o) => (typeof o === 'string' ? o : o.name) === value);

                if (option && (typeof option === 'string' || !option.requireLogin)) {
                  setNumSentences(e.target.value as string);
                } else {
                  setShowSignUpPage(`'Generate ${value} sentences'`, {
                    tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                    tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                  });
                  trackAnalyticsEvent({
                    eventFor: 'button',
                    isAnonymousUser: !user,
                    payload: {
                      label: 'Clicked Locked Option',
                      component_name: COMPONENT_NAMES.contentai_ai_tools,
                      screen_name: SCREEN_NAMES.contentai_ai_tools,
                      tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                      tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                      option_name: `Generate ${value} sentences`,
                      isQwaDashboard: isQwaDashboard,
                    },
                  });
                }
              }}
              classes={classes}
            />
          </div>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomerDropDownWithLock
                label="Change Tone"
                value={tone}
                options={changeToneOptions}
                onChange={(e) => {
                  const value = e.target.value as string;
                  const option = changeToneOptions.find((o) => (typeof o === 'string' ? o : o.name) === value);
                  if (option && (typeof option === 'string' || !option.requireLogin)) {
                    setTone(value);
                  } else {
                    setShowSignUpPage(`'Rewrite with ${value} tone'`, {
                      tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                      tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                    });
                    trackAnalyticsEvent({
                      eventFor: 'button',
                      isAnonymousUser: !user,
                      payload: {
                        label: 'Clicked Locked Option',
                        component_name: COMPONENT_NAMES.contentai_ai_tools,
                        screen_name: SCREEN_NAMES.contentai_ai_tools,
                        tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                        tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                        option_name: `Rewrite with ${value} tone`,
                        isQwaDashboard: isQwaDashboard,
                      },
                    });
                  }
                }}
                classes={classes}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomerDropDownWithLock
                label="Language"
                value={outputLanguage}
                options={LANGUAGES.map(
                  (language) => language?.name?.split(';')?.[0]?.split(',')?.[0]?.split('(')?.[0]
                )?.sort()}
                onChange={(e) => {
                  setOutputLanguage(e.target.value as string);
                }}
                classes={classes}
              />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            label={
              <div>
                <p className={`m-0 ${classes.additionInstructionsText}`}>
                  Additional instructions you would like to include{' '}
                  {!hasValidSubscription && !enableLockedOption ? null : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      style={{ marginBottom: '-3px' }}
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z"
                        fill="#FFC72C"
                      />
                    </svg>
                  )}
                </p>
              </div>
            }
            value={instructions}
            onChange={(e) => setInstructions(e.target.value)}
            multiline
            rows={!hasValidSubscription && !enableLockedOption ? 1 : 4}
            className={`${classes.textAreaInput} no-border`}
            variant="outlined"
            inputProps={{
              readOnly: !hasValidSubscription && !enableLockedOption ? true : false,
            }}
            InputProps={{
              style: { backgroundColor: '#fff', borderRadius: '4px !important' },
              endAdornment:
                !hasValidSubscription && !enableLockedOption ? (
                  <InputAdornment position="end">
                    <Lock className={classes.lockIcon} />
                  </InputAdornment>
                ) : null,
            }}
            onClick={() => {
              if (setShowSignUpPage && !hasValidSubscription && !enableLockedOption) {
                setShowSignUpPage("'Add Additional Instructions'", {
                  tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                  tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                });
                trackAnalyticsEvent({
                  eventFor: 'button',
                  isAnonymousUser: !user,
                  payload: {
                    label: 'Clicked Locked Option',
                    component_name: COMPONENT_NAMES.contentai_ai_tools,
                    screen_name: SCREEN_NAMES.contentai_ai_tools,
                    tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                    tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                    option_name: 'Add Additional Instructions',
                    isQwaDashboard: isQwaDashboard,
                  },
                });
              }
            }}
          />
          {!qttr_tools_auth && !user && (
            <>
              <ReCAPTCHA
                className={classes.recaptcha}
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                onChange={handleRecaptchaChange}
              />
              {captchaError?.includes('recaptchaValue') && (
                <FormHelperText className="red">Please complete the reCAPTCHA to verify you're human.</FormHelperText>
              )}
              <SkipCaptcha
                classes={classes}
                meta={{
                  component_name: COMPONENT_NAMES.contentai_ai_tools,
                  screen_name: SCREEN_NAMES.contentai_ai_tools,
                  tool_name: CONTENT_AI_TOOL_NAME.paragraph_writer,
                  tool_category: CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools,
                }}
                setShowVerifyEmailPopup={setShowVerifyEmailPopup}
              />
            </>
          )}
          <div className={`${isCreditsShown ? classes.creditsShown : classes.freeCreditsShown}`}>
            {isCreditsShown ? (
              <CreditsInfo
                classes={classes}
                creditsRemaining={creditsRemaining}
                creditsNeeded={creditsNeeded}
                usagePerDay={usagePerDay}
              />
            ) : !isQwaDashboard || showFreeToolsUsage ? (
              <CreditsInfo
                classes={classes}
                creditsRemaining={freeToolsUsage}
                creditsNeeded={creditsNeeded}
                usagePerDay={isCorpEmail ? 10 : 7}
                showFreeToolsUsage={showFreeToolsUsage}
              />
            ) : null}
            <div className={`d-flex ${classes.buttonGroup}`} style={{ marginTop: '16px' }}>
              <Button
                style={{ float: 'right' }}
                className={`${classes.toolsYellowCTA} ${classes.toolsOutlinedCTA} ${classes.button}`}
                onClick={() => {
                  setKeywords('');
                  setNumSentences('5');
                  setInstructions('');
                }}
              >
                Clear
              </Button>
              <Button
                className={`${classes.toolsYellowCTA} ${classes.button}`}
                color="primary"
                onClick={() =>
                  handleGenerateOutput(
                    creditsRemaining,
                    creditsNeeded,
                    isQwaDashboard,
                    session,
                    qttr_tools_daypass_auth,
                    setShowMinimumCreditsNeededMsg,
                    setShowBuyOnePass,
                    handleGenerateParagraph,
                    trackAnalyticsEvent,
                    freeToolsUsage,
                    showFreeToolsUsage
                  )
                }
              >
                Generate Paragraph
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ParagraphGenerator;
